/* GAZLESS — verrou d'interface.
   Décourage la copie et l'inspection, et fige l'échelle d'affichage.
   Chargé depuis gz-announcement, donc présent sur toutes les pages du thème.

   Ce que ça fait vraiment : ça met un obstacle devant l'utilisateur pressé.
   Ce que ça ne fait pas : protéger le contenu. Les outils de développement
   restent accessibles par le menu du navigateur, le code source par l'URL
   view-source:, et les images par l'onglet réseau. Aucun site ne peut empêcher
   ça — le HTML, le CSS et les images sont livrés au navigateur par construction.

   Les champs de formulaire restent sélectionnables : sans ça, le code promo,
   la recherche et le paiement deviennent inutilisables.
*/
(function () {
  'use strict';

  var EDITABLE = 'input, textarea, select, [contenteditable="true"], [contenteditable=""]';

  function isEditable(el) {
    return !!(el && el.closest && el.closest(EDITABLE));
  }

  /* ---- 1. clic droit ---- */
  document.addEventListener(
    'contextmenu',
    function (e) {
      if (isEditable(e.target)) return;
      e.preventDefault();
    },
    { capture: true }
  );

  /* ---- 2. sélection de texte ---- */
  var style = document.createElement('style');
  style.textContent =
    'html{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;' +
    '-webkit-touch-callout:none}' +
    'input,textarea,select,[contenteditable="true"],[contenteditable=""]{' +
    '-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}';
  (document.head || document.documentElement).appendChild(style);

  document.addEventListener(
    'selectstart',
    function (e) {
      if (isEditable(e.target)) return;
      e.preventDefault();
    },
    { capture: true }
  );

  document.addEventListener(
    'dragstart',
    function (e) {
      if (e.target && e.target.tagName === 'IMG') e.preventDefault();
    },
    { capture: true }
  );

  /* ---- 3. copier / couper hors champ de saisie ---- */
  ['copy', 'cut'].forEach(function (ev) {
    document.addEventListener(
      ev,
      function (e) {
        if (isEditable(e.target)) return;
        e.preventDefault();
      },
      { capture: true }
    );
  });

  /* ---- 4. raccourcis d'inspection ---- */
  document.addEventListener(
    'keydown',
    function (e) {
      var k = (e.key || '').toLowerCase();
      var ctrl = e.ctrlKey || e.metaKey;

      // F12
      if (k === 'f12') { e.preventDefault(); return; }
      // Ctrl/Cmd + Maj + I / J / C  (inspecteur, console, sélecteur)
      if (ctrl && e.shiftKey && (k === 'i' || k === 'j' || k === 'c')) { e.preventDefault(); return; }
      // Cmd + Alt + I / J / C  (Safari, Chrome macOS)
      if (e.metaKey && e.altKey && (k === 'i' || k === 'j' || k === 'c')) { e.preventDefault(); return; }
      // Ctrl/Cmd + U  (code source)
      if (ctrl && !e.shiftKey && k === 'u') { e.preventDefault(); return; }
      // Ctrl/Cmd + S  (enregistrer la page)
      if (ctrl && !e.shiftKey && k === 's' && !isEditable(e.target)) { e.preventDefault(); return; }
      // Ctrl/Cmd + A  hors champ de saisie
      if (ctrl && k === 'a' && !isEditable(e.target)) { e.preventDefault(); return; }
      // Ctrl/Cmd + molette / +/- : zoom clavier
      if (ctrl && (k === '+' || k === '=' || k === '-' || k === '0')) { e.preventDefault(); return; }
    },
    { capture: true }
  );

  /* ---- 5. zoom ---- */
  // meta viewport : on fige l'échelle sans réécrire layout/theme.liquid
  var mv = document.querySelector('meta[name="viewport"]');
  if (!mv) {
    mv = document.createElement('meta');
    mv.setAttribute('name', 'viewport');
    (document.head || document.documentElement).appendChild(mv);
  }
  mv.setAttribute('content', 'width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover');

  // pincement et double-tap (iOS ignore user-scalable=no depuis iOS 10)
  document.addEventListener('gesturestart', function (e) { e.preventDefault(); }, { passive: false });
  document.addEventListener('gesturechange', function (e) { e.preventDefault(); }, { passive: false });
  document.addEventListener('gestureend', function (e) { e.preventDefault(); }, { passive: false });

  document.addEventListener(
    'wheel',
    function (e) { if (e.ctrlKey) e.preventDefault(); },
    { passive: false, capture: true }
  );

  var lastTouch = 0;
  document.addEventListener(
    'touchend',
    function (e) {
      var now = Date.now();
      if (now - lastTouch <= 320) e.preventDefault();
      lastTouch = now;
    },
    { passive: false, capture: true }
  );

  document.addEventListener(
    'touchmove',
    function (e) { if (e.touches && e.touches.length > 1) e.preventDefault(); },
    { passive: false, capture: true }
  );
})();
